export const getTopics = (language: string) => {
	return {
		url: `myconnect/ebu_${language}/content?srv=cmpnt&cmpntname=ttcategories&source=library`,
	};
};
